import { Route, Routes, BrowserRouter } from 'react-router-dom'
import MainWrapper from './layout/MainWrapper'
import PrivateRoute from './layout/PrivateRoute'
import Index from './views/base/Home'
// import Register from './views/auth/Register'
import Aboutb from './views/base/About'
import Contactb from './views/base/Contact'
import AboutP from './views/instructor/AboutPrivate'
import ContactP from './views/instructor/ContactPrivate'

// User Authentication imports
import Login from './views/auth/login/Login'
import SignUp from './views/auth/signup/Signup'
import Logout from './views/auth/Logout'

// Dashbaord imports
import Home from './views/dashboard/pages/Home'
import Client from './views/dashboard/pages/Client'
import Profile from './views/dashboard/pages/Profile'
import FamilyMembers from './views/dashboard/pages/FamilyMembers'
import MemberFiles from './views/dashboard/pages/FamilyMemberFiles'
import Programs from './views/dashboard/pages/Program'

import View from './views/instructor/View'

// import Verify from 'a./views/instructor/Verify'

function App() {
  return (
    <BrowserRouter>
      <MainWrapper>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<Aboutb />} />
          <Route path="/contact" element={<Contactb />} />
          {/* <Route path="/register/" element={<Register />} /> */}
          <Route path="/login/" element={<Login />} />
          <Route path="/signup/" element={<SignUp />} />
          <Route path="/logout/" element={<Logout />} />
          <Route element={<PrivateRoute />}>
            <Route path="/dashboard/home" element={<Home />} />
            <Route path="/dashboard/client" element={<Client />} />
            <Route path="/dashboard/program" element={<Programs />} />

            <Route
              path="/dashboard/client/:clientId/family/"
              element={<FamilyMembers />}
            />
            <Route
              path="/dashboard/client/:clientId/family/:memberId/files/"
              element={<MemberFiles />}
            />
            <Route
              path="/dashboard/client/:clientId/family/:memberId/folders/:folderId/"
              element={<MemberFiles />}
            />
            <Route
              path="/dashboard/client/:clientId/family/:memberId/folders/:folderId/subfolders/:folderId/"
              element={<MemberFiles />}
            />
            <Route
              path="/dashboard/client/:clientId/family/:memberId/folders/:folderId/subfolders/"
              element={<MemberFiles />}
            />

            <Route path="/profile" element={<Profile />} />
            <Route path="/abouts" element={<AboutP />} />
            <Route path="/contacts" element={<ContactP />} />
            <Route path="/home" element={<View />} />
          </Route>
          {/* <Route path="/login/verify/" element={<TeacherProfile />} /> */}
          {/* <Route path="/logout/" element={<Logout />} /> */}
        </Routes>
      </MainWrapper>
    </BrowserRouter>
  )
}
export default App
